export default __webpack_public_path__ + "014a513fe0461ac43d3a6751cf35c041.svg";